import React, { FC, useState, useRef, useEffect } from 'react';
import { Text, withSitecoreContext } from '@sitecore-jss/sitecore-jss-react';
import { TNewsLetterSubscriptionProps, backgroundTheme } from './types/newsLetterSubscription.types';
import { NewsLetterPopUpModel } from './models/newsLetterSubscription.model';
import { windowService } from '../../utils/window.utils';
import CTA from '../@shared/cta';
import ctaTypes from '../../enums/CTA.enums';
import Icon from '../@shared/icon';
import Picture from '../@shared/picture';
import UnreleasedComponent from '../@shared/unreleasedComponent';
import { iconSize } from '../../constants/icon.constants';
import './styles.scss';

const NewsLetterSubscription: FC<TNewsLetterSubscriptionProps> = (props: TNewsLetterSubscriptionProps) => {
  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [isHidden, setIsHidden] = useState<boolean>(true);
  const newsLetterBarRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    setTimeout(() => {
      const oneTrust = windowService()?.OneTrust;
      if (oneTrust) {
        const oneTrustAlertBoxInterval = setInterval(() => {
          if (oneTrust.IsAlertBoxClosed()) {
            clearInterval(oneTrustAlertBoxInterval);
            setTimeout(() => setIsHidden(false), 8000);
          }
        }, 100);
      } else {
        setTimeout(() => setIsHidden(false), 8000);
      }
    });
  }, []);

  const closePromoBanner = () => {
    setIsOpen(false);
    setTimeout(() => {
      newsLetterBarRef?.current?.classList?.add('news-letter-subscription__bar--show');
    }, 500);
  };

  const hideNewsLetterBar = () => newsLetterBarRef?.current?.classList?.remove('news-letter-subscription__bar--show');

  const model = new NewsLetterPopUpModel(props);

  // Component is unreleased
  if (model.isUnreleased) {
    return <UnreleasedComponent />;
  }


  return (
    <>
      {
        isHidden ? null :
          <>
            <div
              className={`news-letter-subscription__bar ${(model.backgroundtheme === backgroundTheme.black) && 'news-letter-subscription__bar--black'}`}
              ref={newsLetterBarRef}
              onClick={() => {
                setIsOpen(true);
                hideNewsLetterBar();
              }}
            >
              <div
               className={`news-letter-subscription__close-bar`}
               onClick={(e) => {
                e.stopPropagation();
                hideNewsLetterBar();
              }}
              >
                <Icon
                  iconName="action-close-circle-full"
                  size={iconSize.dsk}
                  color="white"
                />
              </div>
              <span>{`${model.newsSubscriptionTitle?.value}`}</span>
            </div>

            <div
              className={`news-letter-subscription__container ${!isOpen ? 'news-letter-subscription__container--closed' : ''} ${(model.backgroundtheme === backgroundTheme.black) && 'news-letter-subscription__container--black'}`}
            >
              <button
                className="news-letter-subscription__close-button"
                onClick={() => {
                  closePromoBanner();
                }
                }
              >
                <Icon iconName="action-close" size={iconSize.dsk} color="white" />
              </button>
              <div className="news-letter-subscription">
                {model.image?.value?.src && <div className="news-letter-subscription__image-wrapper">
                  <Picture
                    editorialImageProps={{
                      id: props.id,
                      desktopImage: model?.image,
                      desktopTransformation: 'Size300',
                      mobileTransformation: 'Size500',
                      cssClassPictureEl: 'news-letter-subscription__image',
                    }}
                  />
                </div>}
                <div className="news-letter-subscription__content">
                  <Text tag={'h2'} className="news-letter-subscription__heading" field={model.title} />
                  <Text tag="p" className="news-letter-subscription__text" field={model.description} />
                  <CTA
                    type={(model.backgroundtheme === backgroundTheme.black) ? ctaTypes.primaryRed : ctaTypes.primaryWhite}
                    field={model.link}
                    extraClassName="news-letter-subscription__cta"
                  />
                </div>
              </div>
            </div>
          </>
      }
    </>

  );
};

export default withSitecoreContext()(NewsLetterSubscription);
